/**
 * ShimmerBar - thin animated wave bar indicating background data loading.
 * Always occupies its 2px height to prevent layout shift; hidden when not visible.
 */
export function ShimmerBar({ visible = true }: { visible?: boolean }) {
  return (
    <>
      <div
        className={`h-0.5 w-full overflow-hidden ${visible ? 'bg-primary-100 dark:bg-primary-800' : ''}`}
      >
        {visible ? (
          <div className="shimmer-slide h-full w-1/4 rounded-full bg-gradient-to-r from-transparent via-primary-400 to-transparent dark:via-primary-500" />
        ) : null}
      </div>
      <style jsx>{`
        .shimmer-slide {
          animation: shimmer-slide 1.8s ease-in-out infinite;
        }
        @keyframes shimmer-slide {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(500%);
          }
        }
      `}</style>
    </>
  )
}
